export default __webpack_public_path__ + "static/media/imagem_livewatch.d388d553.png";